import * as THREE from 'three'
import { ParametricGeometry } from 'three/examples/jsm/geometries/ParametricGeometry'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { custom } from '../../shaders/custom.js'

const canvas = document.querySelector('#canvas');
const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
console.log('gg')


const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 10000);
camera.position.z = 4;



const scene = new THREE.Scene();


const geometry = new ParametricGeometry(grayKelinFunc, 200, 200);







function vertexShader() {
    return `

    uniform float time ; 
      varying vec3 vUv; 
  attribute vec3 position0;

  uniform float ratio ;
  uniform vec3 uLightPos;
  uniform float z;

varying vec3 vNormal;
varying vec3 vSurfaceToLight;
varying vec2 Uv;

      void main() {
        vNormal = normalize(normalMatrix * normal);
        vUv = position;
        Uv = vUv.xy ; 
        
      
        vec4 modelViewPosition = modelViewMatrix * vec4(position   , 1.0);
        gl_Position = projectionMatrix * modelViewPosition; 
        vec3 surfaceToLightDirection = vec3( modelViewMatrix * vec4(position, 1.0));
  vec3 worldLightPos = vec3( viewMatrix * vec4(uLightPos, 1.0));
  vSurfaceToLight = normalize(worldLightPos - surfaceToLightDirection);
      }
    `
}
console.log(vertexShader.ratio)

function fragShader() {
    return `
    
    uniform vec3 uLightColor;

uniform float uLightIntensity;
varying vec3 vNormal;
varying vec3 vSurfaceToLight;
    uniform vec3 colorA; 
    uniform vec3 colorB; 
    uniform float z;
    uniform float y;

    varying vec3 vUv;
    uniform float time; 
    vec3 light_reflection(vec3 lightColor) {
        // AMBIENT is just the light's color
        vec3 ambient = lightColor;
      
        //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        // DIFFUSE  calculations
        // Calculate the cosine of the angle between the vertex's normal
        // vector and the vector going to the light.
        vec3 diffuse = lightColor * dot(vSurfaceToLight, vNormal);
      
        // Combine 
        return (ambient + diffuse);
      }
    void main() {
      
        vec3 light_value = light_reflection(uLightColor);
        light_value *= uLightIntensity;
        vec3 color = vec3(mix(colorA, colorB*  light_value   , vUv.z + 0.3 * 1.2));
        gl_FragColor = vec4(color,1.0)   ;
    }
`

}


let material = new THREE.ShaderMaterial({
    uniforms: {
        time: { value: 0.0 },
        resolution: new THREE.Uniform(new THREE.Vector2()),
        colorA: new THREE.Uniform(new THREE.Vector3(0., 0., 0.)),
        colorB: new THREE.Uniform(new THREE.Vector3(1., 1., 1.)),

        z: { value: 0.0 },
        y: { value: 1.5 },

        ratio: { value: 0.0 },
        uLightPos: {
            value: new THREE.Vector3(0, 0, 0) // position of spotlight
        },
        uLightColor: {
            value: new THREE.Color(0x313638) // default light color
        },
        uLightIntensity: {
            value: 0.7 // light intensity
        },
        uTexture: { value: 0.0 }
    },
    fragmentShader: fragShader(),
    vertexShader: vertexShader(),
    side: THREE.DoubleSide,
})




let m = material.clone();

let mesh = new THREE.Mesh(geometry, m);

scene.add(mesh);

mesh.position.y = 0.;
mesh.rotation.x = -0.7;


mesh.rotation.y = Math.PI / 2;





var composer, effect1;

function initPost() {
    composer = new EffectComposer(renderer);
    composer.addPass(new RenderPass(scene, camera));

    effect1 = new ShaderPass(custom);

    composer.addPass(effect1);



}
initPost();





function resizeRendererToDisplaySize(renderer) {
    const canvas = renderer.domElement;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const needResize = canvas.width !== width || canvas.height !== height;
    if (needResize) {
        renderer.setSize(width, height, false);
    }
    return needResize;
}

function grayKelinFunc(u, v, target) {

    u *= Math.PI * 4
    v *= Math.PI * 2

    let a = 3;
    let n = 3;
    let m = 1;
    let x = 0.15 * (a + Math.cos(n * u / 2.0) * Math.sin(v) - Math.sin(n * u / 2.0) * Math.sin(2 * v)) * Math.cos(m * u / 2.0)
    let y = 0.15 * (a + Math.cos(n * u / 2.0) * Math.sin(v) - Math.sin(n * u / 2.0) * Math.sin(2 * v)) * Math.sin(m * u / 2.0)
    let z = 0.15 * (Math.sin(n * u / 2.0) * Math.sin(v) + Math.cos(n * u / 2.0) * Math.sin(2 * v))
    target.set(x, y, z);
}


var btn = document.getElementById('btn');

btn.addEventListener('click', () => {
    console.log('done')
    let myinterval = setInterval(() => {

        effect1.uniforms['progress'].value += 0.004;


        if (effect1.uniforms['progress'].value >= 1) {
            clearInterval(myinterval)

        }




    }, 3)
})





function render() {
    let time = 0.0005;
    time += 0.0005
    if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement;
        camera.aspect = canvas.clientWidth / canvas.clientHeight;
        camera.updateProjectionMatrix();
    }
    effect1.uniforms['time'].value += time;


    mesh.rotation.z += time;
    mesh.rotation.y += time;




    //renderer.render(scene, camera);
    composer.render(scene, camera);

    composer.setSize(window.innerWidth, window.innerHeight)
    composer.setPixelRatio(window.innerWidth / window.innerHeight);
    requestAnimationFrame(render);
}


render()